module.exports = __webpack_public_path__ + "a242f6888e365a7d84c0b0c7f1637353.jpg";